import bannedKeywordsData from '../assets/data/banned_keywords.json';

const BANNED_KEYWORDS = bannedKeywordsData.keywords.sort((a, b) => b.length - a.length);
const HIGHLIGHT_STYLE = 'background-color: #ffebee; color: #c62828; padding: 2px 4px; border-radius: 3px; font-weight: bold;';

const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const createWordRegex = (keyword) => new RegExp(`\\b${escapeRegex(keyword)}\\b`, 'gi');
const createTestRegex = (keyword) => new RegExp(`\\b${escapeRegex(keyword)}\\b`, 'i');

// Escape HTML entities so untrusted text can't inject markup when
// the result is used with dangerouslySetInnerHTML.
const escapeHtml = (str) =>
  str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');

export const highlightBannedWords = (text) => {
  if (!text) return text;
  // Escape first so any HTML in the title becomes inert, then wrap
  // matched banned words in hardcoded <span> tags (safe, not from user input).
  const escaped = escapeHtml(text);
  return BANNED_KEYWORDS.reduce((result, keyword) => {
    return result.replace(createWordRegex(keyword), `<span style="${HIGHLIGHT_STYLE}">$&</span>`);
  }, escaped);
};

export const containsBannedWords = (text) => {
  if (!text) return false;
  return BANNED_KEYWORDS.some(keyword => createTestRegex(keyword).test(text));
};

// Title validation functions
export const getTitleLength = (title) => title?.length || 0;

export const isTitleTooLong = (title, maxLength = 200) => getTitleLength(title) > maxLength;

export const validateTitleForAmazon = (title, maxLength = 200) => {
  const length = getTitleLength(title);
  return { length, isValid: length <= maxLength, isTooLong: length > maxLength, maxLength };
};
